const subuserStatementsES = {
    "view": {
        "table": {
            "title": "La lista de declaraciones de su subusuario",
            "column": {
                "type": "Tipo",
                "year": "Año",
                "month": "Mes",
                "issue_year": "Año de emisión",
                "issue_month": "Mes de emisión",
                "description": "Descripción",
                "amount": "Cantidad",
                "status": "Estado",
                "details": "Detalles",
                "overview": "Resumen",
                "action": "Acción"
            },
            "button": {
                "export_csv": "Exportar CSV",
                "download": "Descargar"
            },
            "placeholder": {
                "search": "Buscar..."
            },
            "label": {
                "statusOpen": "Abierto",
                "statusPaid": "Pagado",
                "typeLicensing": "Licencias",
                "typeRegular": "Regular",
                "typeAudioMasteringServices": "Masterización de Audio - Servicios",
                "typeVinylEarnings": "Ganancias de Vinilo",
                "typeOffset": "Compensación",
                "typeNotKnown": "Desconocido",
                "monthJanuary": "Enero",
                "monthFebruary": "Febrero",
                "monthMarch": "Marzo",
                "monthApril": "Abril",
                "monthMay": "Mayo",
                "monthJune": "Junio",
                "monthJuly": "Julio",
                "monthAugust": "Agosto",
                "monthSeptember": "Septiembre",
                "monthOctober": "Octubre",
                "monthNovember": "Noviembre",
                "monthDecember": "Diciembre"
            },
            "dropdown": {
                "markAsPaid": "Marcar como PAGADO",
                "markAsOpen": "Marcar como ABIERTO",
                "action": "Acción"
            },
            "message": {
                "statementUnavailable": "Todas las declaraciones emitidas antes de enero de 2023 están disponibles como archivos adjuntos ZIP en su correo electrónico."
            }
        },
        "message": {
            "successMarkedOpen": "¡La declaración del subusuario ha sido marcada como ABIERTA!",
            "successMarkedPaid": "¡La declaración del subusuario ha sido marcada como PAGADA!",
            "error": "¡Algo salió mal! Por favor, actualice la página e intente de nuevo."
        },
        "modal": {
            "markAsPaid": {
                "header": "Marcar declaración como PAGADA",
                "body": "¿Está seguro de que desea marcar la declaración {{statementName}} como PAGADA?"
            },
            "markAsOpen": {
                "header": "Marcar declaración como ABIERTA",
                "body": "¿Está seguro de que desea marcar la declaración {{statementName}} como ABIERTA?"
            }
        }
    },
    "viewOnly": {
        "table": {
            "title": "Su lista de declaraciones",
            "column": {
                "name": "Nombre de la declaración",
                "type": "Tipo",
                "quarter": "Trimestre",
                "year": "Año",
                "month": "Mes",
                "description": "Descripción",
                "amount": "Cantidad",
                "status": "Estado",
                "overview": "Resumen",
                "details": "Detalles"
            },
            "button": {
                "download": "Descargar",
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Buscar..."
            },
            "label": {
                "statusOpen": "Abierto",
                "statusPaid": "Pagado",
                "typeLicensing": "Licencias",
                "typeRegular": "Regular",
                "typeAudioMasteringServices": "Masterización de Audio - Servicios",
                "typeVinylEarnings": "Ganancias de Vinilo",
                "typeOffset": "Compensación",
                "typeNotKnown": "Desconocido",
                "quarterQ1": "T1",
                "quarterQ2": "T2",
                "quarterQ3": "T3",
                "quarterQ4": "T4",
                "monthJanuary": "Enero",
                "monthFebruary": "Febrero",
                "monthMarch": "Marzo",
                "monthApril": "Abril",
                "monthMay": "Mayo",
                "monthJune": "Junio",
                "monthJuly": "Julio",
                "monthAugust": "Agosto",
                "monthSeptember": "Septiembre",
                "monthOctober": "Octubre",
                "monthNovember": "Noviembre",
                "monthDecember": "Diciembre"
            },
            "message": {
                "statementUnavailable": "Todas las declaraciones emitidas antes de enero de 2023 fueron enviadas por correo electrónico a su gerente de cuenta."
            }
        }
    }
};

export default subuserStatementsES;